/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-14 17:45:57
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2022-07-28 11:51:51
 * @FilePath: \baishu_react_ui\src\components\BsyBatchEditPane\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import { BsyWidget } from '../BsyWidget';
import './index.css'
import { ReactSortable } from "react-sortablejs";

import { BsyConfig } from '../../global/BsyConfig';
import BsyIconBtn from '../BsyIconBtn';
import BsyMsgBubble from '../BsyMsgBubble';
import BsyFieldsSelectPane from '../BsyFieldsSelectPane';
import { BsyUtils } from '../../utils/Utils';

export default class BsyFieldSortPane extends BsyWidget {

    static defaultProps = {
        baseCls: "bsy-field-sort-pane",
        entryList: {},
        entryId: null,
        name: '',
        sort: [],
        onStopEdit: null,

    }
    constructor(props) {
        super(props);
        this.element = React.createRef();


        this.initSortMap(props.sort);
        this.state = {
            text4add: React.language("dash.sort.add"),
            fields: this.initFieid(props.entryList, props.sort),
            ...props,
            entryList: this.filterEntryList({ ...props.entryList })
        }


    }

    initSortMap = (sort) => {
        let that = this;
        that.sortMap = {};
        BsyUtils.forEach(sort, (key, data) => {
            BsyUtils.forEach(data, (key1, data1) => {
                that.sortMap[key1] = data1;
            })

        })
    }

    initSort = (fields) => {
        for (let i = 0; i < fields.length; i++) {
            if (fields[i].type === "user" || fields[i].type === "dept") {
                this.sortMap[fields[i].name] = -1;
            } else {
                if (!this.sortMap[fields[i].name]) {
                    this.sortMap[fields[i].name] = 1;
                }
            }
        }
    }

    initFieid = (entryList, sort) => {
        let that = this;
        let fields = [];
        this.initFieldMap = {};
        BsyUtils.forEach(entryList, (a1, b1) => {
            for (let i = 0; i < b1.fields.length; i++) {
                if (b1.fields[i].type === 'subform') {

                } else {
                    // if (that.sortMap[b1.fields[i].name]) {
                    //     fields.push(b1.fields[i])
                    // }
                    that.initFieldMap[b1.fields[i].name] = { ...b1.fields[i] };
                }

            }
        })
        BsyUtils.forEach(sort, (key, data) => {
            BsyUtils.forEach(data, (key1, data1) => {
                // that.sortMap[key1] = data1;
                if (that.initFieldMap[key1]) {
                    fields.push(that.initFieldMap[key1])
                }
            })
        })

        return fields;
    }

    filterEntryList = (entryList) => {
        let availableFields = [...BsyConfig().LimitFields.dashSort, 'user', 'dept'];
        BsyUtils.forEach(entryList, (a1, b1) => {
            let fields = [];
            for (let i = 0; i < b1.fields.length; i++) {
                if (b1.fields[i].type === 'subform') {

                } else {
                    if (availableFields.indexOf(b1.fields[i].type) > -1) {
                        fields.push(b1.fields[i])
                    }
                }
            }
            entryList[a1].fields = fields;
        })
        return entryList;
    }

    getContext = (e) => {
        this.contextMap[e.options.widgetId] = e;
    }

    deleteItem = (res) => {
        const { fields } = this.state;
        const newFields = fields.filter((d) => {
            let ret = d.name !== res.name
            if (!ret) {
                if (this.sortMap[res.name]) {
                    delete this.sortMap[res.name]
                }
            }
            return ret
        })
        this.setState({
            fields: newFields,
            sort: this.getValue(newFields)
        })

    }

    getValue = (newFields) => {
        const { fields } = this.state;
        let value = [];
        let f = newFields || fields;
        for (let i = 0; i < f.length; i++) {
            if (f[i].type === "user" || f[i].type === "dept") {
                value.push({
                    [f[i].name]: -1
                })
            } else {
                value.push({
                    [f[i].name]: this.sortMap[f[i].name]
                })
            }

        }
        return value
    }

    createItem = (res) => {
        switch (res.type) {
            case "user":
            case "dept": {
                return <li className="sortable-item" >
                    <div className="item-text" title={res.text || res.text}>{res.text || res.text}</div>
                    <i className="x-icon icon-trasho" onClick={() => {
                        this.deleteItem(res)
                    }}></i>
                    <i className="x-icon drag-handle icon-drag-table"></i>
                    <div className="x-segment">
                        <div className="x-segment-item item-selected" >{React.language('sort.value.same')}</div>
                    </div>
                </li>
                break;
            } //
            default: {
                return <li className="sortable-item" >
                    <div className="item-text" title={res.text || res.text}>{res.text || res.text}</div>
                    <i className="x-icon icon-trasho" onClick={() => {
                        this.deleteItem(res)
                    }}></i>
                    <i className="x-icon drag-handle icon-drag-table"></i>

                    <div className="x-segment">
                        <div className={"x-segment-item " + (this.sortMap[res.name] == 1 ? "item-selected" : '')}
                            onClick={() => {
                                this.sortMap[res.name] = 1;
                                this.setState({
                                    sort: this.getValue()
                                })
                            }}
                        >{React.language('ascending')}</div>
                        <div className={"x-segment-item " + (this.sortMap[res.name] == -1 ? "item-selected" : '')}
                            onClick={() => {
                                this.sortMap[res.name] = -1;
                                this.setState({
                                    sort: this.getValue()
                                })
                            }}
                        >{React.language('descending')}</div>
                    </div>

                </li>
            }
        }
    }

    onsetList = (evt) => {

        const { fields } = this.state;

        let d1 = fields.map((data) => {
            return data.name;
        })

        let d2 = evt.map((data) => {
            return data.name;
        })

        if (JSON.stringify(d2) !== JSON.stringify(d1)) {
            this.setState({
                fields: [...evt],
                sort: this.getValue(evt)
            })
        }

    }

    render() {
        const { fields } = this.state;
        const { cssName } = this.options;
        return (
            <div className={cssName} ref={this.element} >


                <div className="pane" >
                    <BsyIconBtn
                        iconName={'icon-bsy-add'}
                        text={React.language('dash.sort.add.field')}
                        click={(e) => {
                            e.stopPropagation();
                            let config = {
                                entryList: this.state.entryList,
                                fields: this.state.fields,
                                onStopEdit: (val) => {
                                    this.initSort(val)
                                    this.setState({
                                        fields: val,
                                        sort: this.getValue(val)
                                    }, () => {

                                    })
                                }
                            };
                            let that = this;

                            BsyMsgBubble({
                                anchor: e.currentTarget,

                                contentHTML: (ref) => {
                                    return <BsyFieldsSelectPane
                                        {...config}

                                    ></BsyFieldsSelectPane>
                                },
                                text4Cancel: null,
                                text4Ok: null,
                                theme: this.props.theme,
                                minWidth: "auto",
                                width: 230,
                                contentPadding: 0,
                                edge: 200,
                                hAdjust: 72,
                                dockPosition: "right",
                                onClose: function () {
                                    that.setState({

                                    })
                                    return !1;
                                }
                            })

                        }}
                    />
                    <div className="sortable-list">
                        <ReactSortable

                            forceFallback={'true'}
                            list={fields}
                            setList={this.onsetList}
                            handle={'.drag-handle'}
                        >
                            {
                                fields.map((field) => {
                                    return this.createItem(field)
                                })
                            }
                        </ReactSortable>
                    </div>
                </div>

                <div className="footer">
                    <BsyIconBtn
                        text={React.language('sort')}
                        mode={window.mode + ' blue'}
                        click={(e) => {
                            this.props.onSort && this.props.onSort(this.state.sort);
                        }}
                    />
                    <BsyIconBtn
                        // iconName={'icon-clear'}
                        text={React.language('delete.all')}
                        type={'delete'}
                        mode={window.mode}
                        click={(e) => {
                            this.setState({
                                sort: []
                            }, () => {
                                this.props.onSort && this.props.onSort(this.state.sort);
                            })
                        }}
                    />
                </div>

            </div >
        );
    }
}
